/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthenticatedResponse,
  CheckEmailInput,
  CheckEmailResponse,
  ErrorResponse,
  ResendConfirmEmailInput,
  ResetPasswordInput,
  ResetPasswordSendLinkInput,
  SignInCredentials,
  SignUpCredentials,
  UserData,
} from '../models/index';
import {
    AuthenticatedResponseFromJSON,
    AuthenticatedResponseToJSON,
    CheckEmailInputFromJSON,
    CheckEmailInputToJSON,
    CheckEmailResponseFromJSON,
    CheckEmailResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ResendConfirmEmailInputFromJSON,
    ResendConfirmEmailInputToJSON,
    ResetPasswordInputFromJSON,
    ResetPasswordInputToJSON,
    ResetPasswordSendLinkInputFromJSON,
    ResetPasswordSendLinkInputToJSON,
    SignInCredentialsFromJSON,
    SignInCredentialsToJSON,
    SignUpCredentialsFromJSON,
    SignUpCredentialsToJSON,
    UserDataFromJSON,
    UserDataToJSON,
} from '../models/index';

export interface CheckEmailRequest {
    checkEmailInput: CheckEmailInput;
}

export interface CheckResetTokenRequest {
    token: string;
}

export interface ConfirmEmailRequest {
    token: string;
}

export interface ConfirmInvitationRequest {
    token: string;
}

export interface ResendConfirmationLinkRequest {
    resendConfirmEmailInput?: ResendConfirmEmailInput;
}

export interface ResetPasswordRequest {
    resetPasswordInput?: ResetPasswordInput;
}

export interface ResetPasswordLinkRequest {
    resetPasswordSendLinkInput?: ResetPasswordSendLinkInput;
}

export interface SignInRequest {
    signInCredentials: SignInCredentials;
}

export interface SignUpRequest {
    signUpCredentials: SignUpCredentials;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     * Creates request options for checkEmail without sending the request
     */
    async checkEmailRequestOpts(requestParameters: CheckEmailRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['checkEmailInput'] == null) {
            throw new runtime.RequiredError(
                'checkEmailInput',
                'Required parameter "checkEmailInput" was null or undefined when calling checkEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/check-email`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckEmailInputToJSON(requestParameters['checkEmailInput']),
        };
    }

    /**
     * Checks whether user account with the given email already exists.
     */
    async checkEmailRaw(requestParameters: CheckEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckEmailResponse>> {
        const requestOptions = await this.checkEmailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckEmailResponseFromJSON(jsonValue));
    }

    /**
     * Checks whether user account with the given email already exists.
     */
    async checkEmail(requestParameters: CheckEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckEmailResponse> {
        const response = await this.checkEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for checkResetToken without sending the request
     */
    async checkResetTokenRequestOpts(requestParameters: CheckResetTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling checkResetToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/user/reset-password/check-token/{token}`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns email of 
     */
    async checkResetTokenRaw(requestParameters: CheckResetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserData>> {
        const requestOptions = await this.checkResetTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDataFromJSON(jsonValue));
    }

    /**
     * Returns email of 
     */
    async checkResetToken(requestParameters: CheckResetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserData> {
        const response = await this.checkResetTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for confirmEmail without sending the request
     */
    async confirmEmailRequestOpts(requestParameters: ConfirmEmailRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling confirmEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/user/confirm-email/check/{token}`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Confirms user email with token.
     */
    async confirmEmailRaw(requestParameters: ConfirmEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticatedResponse>> {
        const requestOptions = await this.confirmEmailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     * Confirms user email with token.
     */
    async confirmEmail(requestParameters: ConfirmEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticatedResponse> {
        const response = await this.confirmEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for confirmInvitation without sending the request
     */
    async confirmInvitationRequestOpts(requestParameters: ConfirmInvitationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling confirmInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/user/confirm-invitation/check/{token}`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Confirms user email with token.
     */
    async confirmInvitationRaw(requestParameters: ConfirmInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticatedResponse>> {
        const requestOptions = await this.confirmInvitationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     * Confirms user email with token.
     */
    async confirmInvitation(requestParameters: ConfirmInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticatedResponse> {
        const response = await this.confirmInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resendConfirmationLink without sending the request
     */
    async resendConfirmationLinkRequestOpts(requestParameters: ResendConfirmationLinkRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/user/confirm-email/resend`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResendConfirmEmailInputToJSON(requestParameters['resendConfirmEmailInput']),
        };
    }

    /**
     * Re-sends link to confirm email address.
     */
    async resendConfirmationLinkRaw(requestParameters: ResendConfirmationLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.resendConfirmationLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Re-sends link to confirm email address.
     */
    async resendConfirmationLink(requestParameters: ResendConfirmationLinkRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.resendConfirmationLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resetPassword without sending the request
     */
    async resetPasswordRequestOpts(requestParameters: ResetPasswordRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/user/reset-password/update-password`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordInputToJSON(requestParameters['resetPasswordInput']),
        };
    }

    /**
     * Updates password by using the reset password token.
     */
    async resetPasswordRaw(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.resetPasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Updates password by using the reset password token.
     */
    async resetPassword(requestParameters: ResetPasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.resetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resetPasswordLink without sending the request
     */
    async resetPasswordLinkRequestOpts(requestParameters: ResetPasswordLinkRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/user/reset-password/send-link`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordSendLinkInputToJSON(requestParameters['resetPasswordSendLinkInput']),
        };
    }

    /**
     * Sends link to reset password to the user by the e-mail address.
     */
    async resetPasswordLinkRaw(requestParameters: ResetPasswordLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.resetPasswordLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Sends link to reset password to the user by the e-mail address.
     */
    async resetPasswordLink(requestParameters: ResetPasswordLinkRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.resetPasswordLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for signIn without sending the request
     */
    async signInRequestOpts(requestParameters: SignInRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['signInCredentials'] == null) {
            throw new runtime.RequiredError(
                'signInCredentials',
                'Required parameter "signInCredentials" was null or undefined when calling signIn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/sign-in`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignInCredentialsToJSON(requestParameters['signInCredentials']),
        };
    }

    /**
     * Gets user, password and returns auth token.
     */
    async signInRaw(requestParameters: SignInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticatedResponse>> {
        const requestOptions = await this.signInRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     * Gets user, password and returns auth token.
     */
    async signIn(requestParameters: SignInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticatedResponse> {
        const response = await this.signInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for signUp without sending the request
     */
    async signUpRequestOpts(requestParameters: SignUpRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['signUpCredentials'] == null) {
            throw new runtime.RequiredError(
                'signUpCredentials',
                'Required parameter "signUpCredentials" was null or undefined when calling signUp().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/sign-up`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignUpCredentialsToJSON(requestParameters['signUpCredentials']),
        };
    }

    /**
     * Creates user by email and password.
     */
    async signUpRaw(requestParameters: SignUpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.signUpRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Creates user by email and password.
     */
    async signUp(requestParameters: SignUpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.signUpRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
